
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkProjectdossierDocumentselectionEntryDto } from '../models/work-projectdossier-documentselection-entry-dto';

export function getUpdateProjectdossierTemplateDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(200)]),
    assignToNewProjects: new FormControl<boolean | undefined>(true),
    assignToExistingProjects: new FormControl<boolean | undefined>(false),
    assignFromDate: new FormControl<string | undefined>(undefined),
    roletypeIds: new FormControl<Array<number> | undefined>([]),
    documentselection: new FormControl<WorkProjectdossierDocumentselectionEntryDto[]>([]),
    sortOrder: new FormControl<number | undefined>(undefined),
    active: new FormControl<boolean | undefined>(true),
    visibleForExternalAccessDefault: new FormControl<boolean | undefined>(false),
})
;
}
      